var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"shop-page-layout"}},[_c('Header',{attrs:{"variant":"reduced"}}),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }